export default __webpack_public_path__ + "static/media/alert.88a653d4.png";